import React from "react";
import { Navigate } from "react-router-dom";

const EmpProtectedRoute = ({ children, allowedRoles }) => {
  const token = sessionStorage.getItem("token");
  const roles = JSON.parse(sessionStorage.getItem("roles") || "[]");
  const status = sessionStorage.getItem("status") || "";

  if (!token) return <Navigate to="/" />; // Not logged in

  if (status.toUpperCase() !== "ACTIVE") {
    sessionStorage.clear();
    return <Navigate to="/" />;
  }

  // Check if user has at least one allowed role
  const hasAccess = roles.some((role) => allowedRoles.includes(role));
  if (!hasAccess) return <Navigate to="/" />; // Unauthorized

  return children;
};

export default EmpProtectedRoute;
